import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=4c3451e2&scoped=true&"
import script from "./SaveButton.vue?vue&type=script&lang=ts&"
export * from "./SaveButton.vue?vue&type=script&lang=ts&"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=4c3451e2&prod&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4c3451e2",
  null
  
)

export default component.exports